// src/api_auth.js
import { http } from "./http";

/**
 * Restituisce:
 * {
 *   authenticated: boolean,
 *   requires_setup: boolean,
 *   user_id: number|null,
 *   azienda_id: number|null,
 *   ruolo: string|null,
 *   is_multilocation_manager: boolean
 * }
 */
export async function checkSession() {
  const { data } = await http.get("/api/session_info.php");

  return {
    // ✅ SOLO true se è proprio boolean true
    authenticated: data?.authenticated === true,

    // ✅ SOLO true se è proprio boolean true (evita "false" -> true)
    requires_setup: data?.requires_setup === true,
    requires_subscription: data?.requires_subscription === true,

    user_id: data?.user_id ?? null,
    azienda_id: data?.azienda_id ?? null,
    ruolo: data?.ruolo ?? null,
    is_multilocation_manager: data?.is_multilocation_manager === true,
    inspector_only: data?.inspector_only === true,
  };
}
